import {
  Code2, Smartphone, Server, Globe, Megaphone, ShoppingBag, Building2,
  Cpu, Palette, Sparkles, Search, Mail, BarChart3, Boxes, CreditCard,
  Cloud, HardDrive, Database, Users, Briefcase, BookOpen, MessageCircle,
  FileText, Network, ShieldCheck, Layers, Rocket, Zap, Target, PenTool,
  Layout, Wrench, TrendingUp, Share2, Video, LineChart, Package, Truck,
  GraduationCap, Stethoscope, DollarSign, UserCheck, Building, MapPin, Award,
  Headphones, Brush, Send, Lock, Gauge, Bot, Store, Star, Phone, CheckCircle,
  ClipboardList, CalendarDays, Funnel, Landmark, AtSign, Heart, Tag,
} from "lucide-react";

export const MEGA_MENU_ICONS = {
  Code2, Smartphone, Server, Globe, Megaphone, ShoppingBag, Building2,
  Cpu, Palette, Sparkles, Search, Mail, BarChart3, Boxes, CreditCard,
  Cloud, HardDrive, Database, Users, Briefcase, BookOpen, MessageCircle,
  FileText, Network, ShieldCheck, Layers, Rocket, Zap, Target, PenTool,
  Layout, Wrench, TrendingUp, Share2, Video, LineChart, Package, Truck,
  GraduationCap, Stethoscope, DollarSign, UserCheck, Building, MapPin, Award,
  Headphones, Brush, Send, Lock, Gauge, Bot, Store, Star, Phone, CheckCircle,
  ClipboardList, CalendarDays, Funnel, Landmark, AtSign, Heart, Tag,
} as const;

export type MegaMenuIconName = keyof typeof MEGA_MENU_ICONS;

export const MEGA_MENU_ICON_NAMES = Object.keys(MEGA_MENU_ICONS) as MegaMenuIconName[];

export function resolveMegaMenuIcon(name?: string) {
  if (name && name in MEGA_MENU_ICONS) {
    return MEGA_MENU_ICONS[name as MegaMenuIconName];
  }
  return Sparkles;
}
